import { connect } from 'react-redux'

import { sendBrukerETO } from '../../actions'

import Logging from './LoggingAvPublikum'
import { selectBrukerTyper } from './LoggingAvPublikumSelector'

const brukerState = (state) => ({
    brukertyper: selectBrukerTyper(state)
})
const setBrukerDispatch = (dispatch) => ({
    sendBrukerETO: (brukerETO) => {
        dispatch(sendBrukerETO(brukerETO))
    }
})
export const LoggingAvPublikum = connect(brukerState, setBrukerDispatch)(Logging)
